// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nextBtn {
    display: flex;
    border-radius: 8px;
    align-items: center;
    gap: 4px;
    font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Shared/Components/NextBtn/NextBtn.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB","sourcesContent":[".nextBtn {\n    display: flex;\n    border-radius: 8px;\n    align-items: center;\n    gap: 4px;\n    font-size: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
